import React, { FC, ReactElement } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Button, { ButtonProps } from '@mui/material/Button';
import { clsx } from 'clsx';
import Space, { Type } from '../layout/space';
import SvgIcon from '../icons/SvgIcon';
import { IconAxel } from '../../resources/images';

interface RadiusButtonProps extends ButtonProps {
    title?: string;
    iconElement?: JSX.Element;
    isSelected?: boolean;
    width?: string;
    noSpace?: boolean;
    border?: boolean;
    mode?: 'grey' | 'blue';
}

const RadiusButton: FC<RadiusButtonProps> = (props): ReactElement => {
    const { title, iconElement, isSelected, width, noSpace, border = false, className, mode, ...rest } = props;
    const classes = useStyles();

    if (mode === 'grey') {
        return (
            <Button
                variant="outlined"
                style={{ width }}
                {...rest}
                className={clsx(classes.greyRadiusButton, isSelected && classes.greyBackground, className)}
            >
                {iconElement}
                {title}
                {isSelected && <SvgIcon icon={IconAxel.Check} size="xsmall" />}
            </Button>
        );
    }

    return (
        <Button
            variant="outlined"
            style={{ width }}
            {...rest}
            className={clsx(
                classes.radiusButton,
                border ? isSelected && classes.blueBorder : isSelected && classes.blueBackground,
                className,
                isSelected && 'selected',
            )}
        >
            {iconElement}
            {iconElement && !noSpace && <Space type={Type.horizontal} value={1} />}
            {title}
        </Button>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        radiusButton: {
            color: theme.palette.colors.text.accent,
            height: 50,
            margin: 0,
            borderRadius: 100,
            minWidth: 112,
            padding: 12,
            border: `1px solid ${theme.palette.colors.border}`,
        },
        blueBackground: {
            color: 'white',
            background: theme.palette.secondary.light,
            '&:hover': {
                background: theme.palette.secondary.light,
            },
        },
        blueBorder: {
            borderColor: `${theme.palette.secondary.main}!important`,
            backgroundColor: `${theme.palette.colors.background.selected}!important`,
        },
        greyRadiusButton: {
            color: theme.palette.primary.main,
            height: 40,
            margin: 0,
            gap: 4,
            borderRadius: 100,
            fontSize: 14,
            fontWeight: 400,
            padding: '12px 20px',
            border: 'unset',
            background: `${theme.palette.colors.background.primaryElement}!important`,
            '&:hover': {
                border: 'unset',
            },
        },
        greyBackground: {
            background: `${theme.palette.colors.background.primaryBtn}24`,
            border: `1px solid ${theme.palette.colors.background.primaryBtn}`,
            transition: 'background 0.5s ease, border 0.5s ease', // Ajout de la transition
            '&:hover': {
                background: `${theme.palette.colors.background.primaryBtn}24`,
                border: `1px solid ${theme.palette.colors.background.primaryBtn}`,
            },
        },
    }),
);

export default RadiusButton;
